import React, { useEffect, useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import {
  collection,
  getCountFromServer,
  query,
  where,
  getDocs
} from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { useAuth } from '../AuthContext';
import '../../styles/admin.css';
import Seo from '../../components/Seo';

export default function AdminDashboard() {
  const { currentUser } = useAuth();
  const [articleCounts, setArticleCounts] = useState({ total: 0, published: 0 });
  const [testimonialsCount, setTestimonialsCount] = useState(0);
  const [storiesCount, setStoriesCount] = useState(0);
  const [pendingStoriesCount, setPendingStoriesCount] = useState(0);
  const [totalViews, setTotalViews] = useState(0);

  useEffect(() => {
    let mounted = true;

    const fetchCounts = async () => {
      try {
        const totalSnap = await getCountFromServer(collection(db, 'articles'));
        const publishedQuery = query(
          collection(db, 'articles'),
          where('status', '==', 'published')
        );
        const publishedSnap = await getCountFromServer(publishedQuery);

        const testimonialCountSnap = await getCountFromServer(collection(db, 'testimonials'));
        const storiesCountSnap = await getCountFromServer(collection(db, 'stories'));
        const pendingStoriesSnap = await getCountFromServer(
          query(collection(db, 'stories'), where('status', '==', 'pending'))
        );
        const articleSnap = await getDocs(collection(db, 'articles'));
        if (mounted) {
          setArticleCounts({
            total: totalSnap.data().count || 0,
            published: publishedSnap.data().count || 0
          });
          setTestimonialsCount(testimonialCountSnap.data().count || 0);
          setStoriesCount(storiesCountSnap.data().count || 0);
          setPendingStoriesCount(pendingStoriesSnap.data().count || 0);
          setTotalViews(
            articleSnap.docs.reduce((acc, docItem) => acc + (docItem.data().views || 0), 0)
          );
        }
      } catch (err) {
        console.error('Failed to fetch article counts', err);
      }
    };

    fetchCounts();
    return () => {
      mounted = false;
    };
  }, []);

  const stats = [
      {
        label: 'Total Pengunjung',
        value: totalViews.toLocaleString('id-ID'),
        helper: 'berdasarkan view artikel'
      },
    {
      label: 'Total Artikel',
      value: articleCounts.total,
      helper: 'terbit + draf'
    },
    {
      label: 'Artikel Terbit',
      value: articleCounts.published,
      helper: 'terkini'
    },
      {
        label: 'Testimoni Landing',
        value: testimonialsCount,
        helper: 'pengunjung bersaksi'
      },
      {
        label: 'Cerita Masuk',
        value: pendingStoriesCount,
        helper: `menunggu review (${storiesCount} total)`
      }
  ];

  return (
    <div className="admin-wrapper">
      <Seo title="Admin Panel" description="Halaman admin ruqyah syar'i." canonical="/admin" noindex />
      <aside className="admin-sidebar">
        <div className="admin-brand">
          <div className="symbol">RS</div>
          <div>
            <p className="admin-super">Ruqyah Syar'i Tegal</p>
            <p className="admin-sub">Panel Pengurus</p>
          </div>
        </div>
        <div className="admin-user">
          <div className="admin-user-label">Login sebagai</div>
          <div className="admin-user-email">{currentUser?.email || '-'}</div>
        </div>
        <nav className="admin-nav">
          <NavLink
            to="/admin"
            end
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
          >
            <i className="bi bi-grid-1x2"></i>
            Dashboard
          </NavLink>
          <NavLink
            to="/admin/post"
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
          >
            <i className="bi bi-journal-text"></i>
            Artikel
          </NavLink>
          <NavLink
            to="/admin/testimonials"
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
          >
            <i className="bi bi-chat-quote"></i>
            Testimoni
          </NavLink>
          <NavLink
            to="/admin/stories"
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
          >
            <i className="bi bi-chat-dots"></i>
            Cerita
          </NavLink>
          <NavLink
            to="/admin/settings"
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
          >
            <i className="bi bi-gear"></i>
            Pengaturan
          </NavLink>
        </nav>
      </aside>

      <main className="admin-main">
        <header className="admin-main-header">
          <div>
            <h1>Selamat Datang, Admin</h1>
              <p className="text-muted">Pantau aktivitas ruqyah, kelola artikel, dan awasi statistik dari satu tempat.</p>
          </div>
          <div className="admin-badge">Online</div>
        </header>

        <div className="admin-stats-grid">
          {stats.map(stat => (
            <article key={stat.label} className="admin-stat-card">
              <p>{stat.label}</p>
              <h3>{stat.value}</h3>
              <small>{stat.helper}</small>
            </article>
          ))}
        </div>

        <section className="admin-panel-section">
          <div className="section-head">
            <div>
              <h2>Ringkasan Sistem</h2>
              <p className="text-muted-small">
                Performa artikel dan testimoni terbaru tersaji dalam kartu ringkasan.
              </p>
            </div>
          </div>
          <Outlet />
        </section>
      </main>
    </div>
  );
}
